import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import LoginPage from "../login-page/login-page";
import MainPage from "../mainpage/main-page";
import { Container } from "@material-ui/core";


const styles = theme => ({
  mainApp: {
    margin: "5rem"

  },
  paperCls: {
    padding: "0rem .5rem",
    display: "flex",
    flexDirection: "column"
  },
  bgMain:{
    backgroundColor:'#43658eab',
    height: '100vh'
  }
});

class LandingPage extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
      loginRequired: true,
      customerDetail: {}
    };

  }

  componentWillMount(){
     //this.handleLoginSuccess({Id: 51, Abrv: "BBW", Name: "Bath & Body Works - FMO"});
     //this.handleLoginSuccess({Id: 91, Abrv: "CVS-PHA", Name: "CVS Pharmacy"});
  }

  handleLoginSuccess = (customerDetail) =>{
    this.setState({
      customerDetail,
      loginRequired:false
    })
  }

  handleLogOut(){

    this.setState =( {
      loginRequired: true,
      customerDetail: {}
    });

  }

  handleToggle(){}



  render() {
 
    const {classes} = this.props;

    return <div className={classes.bgMain}>
    
    {
      this.state.loginRequired ? <LoginPage loginEvent={this.handleLoginSuccess} />
     : <MainPage customerDetail={this.state.customerDetail} userId={this.state.userId} 
     />}
    
    </div>;
  }
}

export default withStyles(styles)(LandingPage);
